import { Box, Header } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const HeaderContainer = Box.withConfig({
  paddingX: '$4',
  paddingTop: '$6',
  marginBottom: '$5',
  justifyContent: 'center',
  alignItems: 'center',
  focusable: true,
  accessible: true,
  accessibilityRole: 'header',
});

export const HeaderStyled = Header.withConfig({
  variant: 'hero',
  textAlign: 'center',
  color: theme.token('text-hero-light'),
  fontWeight: 700,
  margin: 0,
  _web: {
    width: '100vw',
    paddingX: '$4',
  },
});

export const ButtonsContainer = Box.withConfig({
  width: 'full',
  paddingY: '$6',
  paddingX: '$4',
});

export const HeroSection = Box.withConfig({
  background: 'transparent',
});

// By design, the floating container and the next element is overlapped. Negative bottom here let us to do it in the most safe way.
export const FloatingContainer = Box.withConfig({
  position: 'absolute',
  bottom: -24,
  minHeight: '$32',
  width: 'full',
  paddingX: '$4',
  paddingY: '$6',
});
